/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 14, height = 13 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0012 4.23859L16.3345 7.57192M18.1462 5.7486C18.5868 5.30812 18.8344 4.71065 18.8345 4.08764C18.8346 3.46463 18.5871 2.86711 18.1467 2.42652C17.7062 1.98592 17.1087 1.73836 16.4857 1.73828C15.8627 1.7382 15.2652 1.98562 14.8246 2.4261L3.70291 13.5503C3.50943 13.7432 3.36634 13.9807 3.28625 14.2419L2.18541 17.8686C2.16388 17.9407 2.16225 18.0172 2.18071 18.0901C2.19916 18.1631 2.23701 18.2296 2.29024 18.2828C2.34347 18.3359 2.4101 18.3737 2.48305 18.392C2.55599 18.4103 2.63255 18.4086 2.70458 18.3869L6.33208 17.2869C6.59306 17.2076 6.83056 17.0653 7.02375 16.8728L18.1462 5.7486Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
